import {
  TrackingV2ContactInfoQuery,
  TrackingV2ContactInfoQueryVariables
} from '@data/__generated__/types.main'
import {useApolloQuery} from 'apollo-hooks'
import gql from 'graphql-tag'

export default function useContactInfo(storeId: string) {
  const {store} = useApolloQuery<TrackingV2ContactInfoQuery, TrackingV2ContactInfoQueryVariables>({
    query: gql`
      query TrackingV2ContactInfo($storeId: ID!) {
        store(storeId: $storeId) {
          _id
          supportOptions {
            phone
            whatsAppNumber
            email
          }
        }
      }
    `,
    variables: {storeId},
    omit: !storeId,
    fetchPolicy: 'cache-first'
  })

  return {
    phone: store?.supportOptions?.phone,
    whatsAppNumber: store?.supportOptions?.whatsAppNumber,
    email: store?.supportOptions?.email
  }
}
